package one.healthium.profile.ui.update_food

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update
import one.healthium.base.preferences.AppPreferences
import one.healthium.domain.user.UserInteractor
import one.healthium.profile.ui.food.models.AmountUiModel
import one.healthium.profile.ui.food.models.FoodUiOptions
import one.healthium.profile.ui.food.models.toOptions
import one.healthium.profile.ui.food_history.models.FoodItemUiModel
import one.healthium.ui.common.event_producer.EventProducer
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel
import kotlin.time.Instant

internal class UpdateFoodViewModel(
    private val userInteractor: UserInteractor,
    appPreferences: AppPreferences,
) : BaseViewModel() {

    private val _state = MutableStateFlow(UpdateFoodUiState())
    val state = _state.asStateFlow()

    val uiMessage = UiMessageManager()
    val events = EventProducer<UpdateFoodEvents>()

    init {
        appPreferences.isMetricFlow
            .onEach { isMetric ->
                _state.update { state ->
                    state.copy(
                        isMetric = isMetric,
                        currentAmount = null,
                    )
                }
            }
            .launch()
    }

    fun onFoodChanged(food: FoodItemUiModel) {
        _state.update { state ->
            state.copy(
                currentFood = food,
                currentAmount = null,
            )
        }
    }

    fun onSaveClicked(options: FoodUiOptions) {
        launch {
            val dayId = _state.value.currentFood?.dayId
            val foodItemId = _state.value.currentFood?.id
            if (dayId == null || foodItemId == null) {
                Logger.e("no dayId: $dayId or foodId: $foodItemId")
                return@launch
            }

            _state.update { state -> state.copy(loading = true) }

            val foodOptions = options.toOptions()
            try {
                userInteractor.setFoodForDate(dayId, foodItemId, foodOptions)
                events.trigger(UpdateFoodEvents.OnFoodSaved)
            } catch (e: Exception) {
                Logger.e(e) { "Failed to add food" }

                uiMessage.add(UiMessage.throwable(e))
            } finally {
                _state.update { state -> state.copy(loading = false) }
            }
        }
    }

    fun onAmountChanged(amount: AmountUiModel) {
        _state.update { state -> state.copy(currentAmount = amount) }
    }

    fun onTimeChanged(time: Instant) {
        _state.update { state ->
            state.copy(
                selectedDate = time,
            )
        }
    }
}